// Connects AVI to the 2.7M word slang glossary to sound human and answer definition lookups.

const DB_URL = "https://v2.betterbase.kaywat.codes/rest/v1";

// In a real environment, you'd pass a public anon key in headers if BetterBase requires it.
const headers = {
    "Content-Type": "application/json"
};

export async function fetchWordOfTheDay() {
    try {
        // Fetch a highly upvoted definition as the Word of the Day
        const res = await fetch(`${DB_URL}/definitions?select=*,words(word)&order=upvotes.desc&limit=50`, { headers });
        if (!res.ok) return null;
        
        const data = await res.json();
        if (data && data.length > 0) {
            // Pick a random top 50 word to keep it fresh
            const randomPick = data[Math.floor(Math.random() * data.length)];
            return {
                word: randomPick.words?.word || "Unknown",
                definition: randomPick.definition
            };
        }
    } catch (err) {
        console.warn("[Harness: Dictionary] Failed to fetch WOTD", err);
    }
    return null;
}

export async function searchSlang(query: string) {
    try {
        // Extract the target word from phrases like "what does rizz mean"
        const cleanQuery = query.toLowerCase().replace(/what does|mean|define|what is|the definition of|\?|/gi, "").trim();
        
        // 1. Find the word_id
        const wordRes = await fetch(`${DB_URL}/words?word=ilike.${cleanQuery}&limit=1`, { headers });
        const wordData = await wordRes.json();
        
        if (!wordData || wordData.length === 0) return null;
        
        // 2. Fetch the top definition
        const defRes = await fetch(`${DB_URL}/definitions?word_id=eq.${wordData[0].id}&order=upvotes.desc&limit=1`, { headers });
        const defData = await defRes.json();
        
        if (defData && defData.length > 0) {
            return {
                word: wordData[0].word,
                definition: defData[0].definition,
                example: defData[0].example
            };
        }
    } catch (err) {
        console.warn("[Harness: Dictionary] Failed to search slang", err);
    }
    return null;
}

export async function getTrendingFlavor() {
    try {
        // Fetch 3 random top trending words for AVI to naturally weave into conversation
        const res = await fetch(`${DB_URL}/definitions?select=*,words(word)&order=upvotes.desc&limit=100`, { headers });
        if (!res.ok) return "";
        
        const data = await res.json();
        if (data && data.length > 0) {
            const flavors = [];
            for(let i = 0; i < 3; i++) {
                const pick = data[Math.floor(Math.random() * data.length)];
                if (pick.words?.word) flavors.push(pick.words.word);
            }
            return flavors.join(", ");
        }
    } catch (err) {
        console.warn("[Harness: Dictionary] Failed to fetch flavor", err);
    }
    return "";
}
